@if(data.type === 'fw'){
<div class="container d-flex flex-column">
  <div class="heading-div d-flex justify-content-between">
    <span class="fc-content"> FW Details</span>
    <div class="img-div" mat-dialog-close>
      <img
        alt="cross"
        class="img-cross"
        src="../../../assets/images/cross_white.svg"
      />
    </div>
  </div>
  <div class="content-div">
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> FW Name </span>
      <span class="fc-content">
        {{ data.updatedBy }}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Contact Number </span>
      <span class="fc-content">
        {{ data.fw_contact_number }}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Email </span>
      <span class="fc-content">
        {{ data.fw_email_id }}
      </span>
    </div>

    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Pincode </span>
      <span class="fc-content">
        {{ data.fw_pincode }}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Address </span>
      <span class="fc-content">
        {{ data.fw_address }}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> District </span>
      <span class="fc-content">
        {{ data.fw_district_name }}
      </span>
    </div>

    <div class="d-flex justify-content-between heading-div">
      <span class="content"> State </span>
      <span class="fc-content">
        {{ data.fw_state_name }}
      </span>
    </div>
  </div>
</div>
}@else{
  <div class="container d-flex flex-column">
  <div class="heading-div d-flex justify-content-between">
    <span class="fc-content"> DA Details</span>
    <div class="img-div" mat-dialog-close>
      <img
        alt="cross"
        class="img-cross"
        src="../../../assets/images/cross_white.svg"
      />
    </div>
  </div>
  <div class="content-div">
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> DA Name </span>
      <span class="fc-content">
        {{ data.reviewedBy }}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Contact Number </span>
      <span class="fc-content">
        {{ data.da_contact_number }}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Email </span>
      <span class="fc-content">
        {{ data.da_email_id }}
      </span>
    </div>

    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Pincode </span>
      <span class="fc-content">
        {{ data.da_pincode}}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> Address </span>
      <span class="fc-content">
        {{ data.da_address}}
      </span>
    </div>
    <div class="d-flex justify-content-between heading-div">
      <span class="content"> District </span>
      <span class="fc-content">
        {{ data.da_district_name }}
      </span>
    </div>

    <div class="d-flex justify-content-between heading-div">
      <span class="content"> State </span>
      <span class="fc-content">
        {{ data.da_state_name }}
      </span>
    </div>
  </div>
</div>
}
